export const PRICE_PAGE = 'PRICE_PAGE';
export const FAVORITE_PAGE = 'FAVORITE_PAGE';
export const NEWS_PAGE = 'NEWS_PAGE';